import React, { useEffect } from "react";
import { TOptions, TOptionValue } from "../optionsUtils";
import Checkbox from "../types/checkbox/Checkbox";
import Radio from "../types/radio/Radio";
import Toggle from "../types/toggle/Toggle";

import "./OptionCard.scss";

interface IProps {
    id: string;
    type: TOptions;
    title?: React.ReactNode;
    value?: TOptionValue;
    onClick?: (e) => void;
    disabled?: boolean;
}

export default function OptionCard(props: IProps) {
    const [value, setValue] = React.useState<TOptionValue>(props.value || "unselected");

    const onClick = (e) => {
        if (props.onClick) {
            props.onClick(e);
        }

        if (props.disabled) {
            return;
        }

        if (value === "selected") {
            setValue("unselected");
        } else if (value === "unselected") {
            setValue("selected");
        } else {
            setValue("indeterminate");
        }
    };

    useEffect(() => {
        if (props.value) {
            setValue(props.value);
        }
    }, [props.value]);

    return (
        <button
            id={props.id + "-option-card"}
            onClick={onClick}
            className={`userful-opiton-card noselect ${
                value === "selected"
                    ? "userful-opiton-card-selected"
                    : value === "indeterminate"
                      ? "userful-opiton-card-indeterminate"
                      : ""
            } 
            ${props.disabled ? "userful-opiton-card-disabled" : ""}`}
        >
            <div className="userful-opiton-card-body">
                <div className="userful-opiton-card-icon">
                    {props.type === "checkbox" && (
                        <Checkbox value={value} onClick={onClick} disabled={props.disabled} />
                    )}
                    {props.type === "radio" && <Radio value={value} onClick={onClick} disabled={props.disabled} />}
                    {props.type === "toggle" && <Toggle value={value} onClick={onClick} disabled={props.disabled} />}
                </div>
                <div className="userful-opiton-card-image"></div>
            </div>
            <div className="userful-opiton-card-text">
                <h1>{props.title}</h1>
            </div>
        </button>
    );
}
